import React, { lazy, Suspense, useEffect, useState } from 'react'

import logo from './logo.svg';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import { LanguagesProvider } from './context/LanguagesContext';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import './App.css';
import CommingSoon from './Pages/CommingSoon';
import ContactHeader from './components/ContactHeader';
import Header from './components/Header';
import Container from './Container';
import './styles/rtl.css'
import Footer from './components/Footer';
import Home from './Pages/Home';
import HomeMobile from './PagesMobile/HomeMobile';
import ContactPage from './Pages/ContactPage';
import ContactMobile from './PagesMobile/ContactMobile';
import Test from './Test';
import ProductsMobile from './PagesMobile/ProductsMobile';
import Products from './Pages/Products';


function App() {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation(); // Get the current route
  
  // Check the window width and update the isMobile state
    useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1160);
    };

    // Set the initial state
    handleResize();

    // Listen for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <LanguagesProvider>
      <div className="App ">
        {!isMobile && 
          <div className='pt-10  w-full px-16 xxxl:px-20'>
              <ContactHeader dis={isMobile}/>
          </div>
        }
        
        <div className={`bg-white  z-[10000] w-full ${isMobile ? 'fixed top-0' : 'sticky top-0 mt-10 px-16 xxxl:px-20 group'}`}>
            <Header dis={isMobile}/>
        </div>
        <Container>
          <Suspense fallback={<div className='w-full h-screen flex justify-center items-center'><AiOutlineLoading3Quarters className='animate-spin text-5xl text-primary'/></div>}>
              <Routes location={location} key={location.pathname}>
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route path='/home' element={isMobile ? <HomeMobile dis/> : <Home/>} smooth duration={500} />
                  <Route path='/products' element={isMobile ? <ProductsMobile/> : <Products/>} smooth duration={500} />
                  <Route path='/contact' element={isMobile ? <ContactMobile/> : <ContactPage/>} smooth duration={500} />
              </Routes>
          </Suspense>
        </Container>
      </div>

    </LanguagesProvider>
    
  );
}

export default App;
